module.exports = __webpack_public_path__ + "static/Syberia3-9992d735429f140eab21379bc9a108ab.webp";